import { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Typography from "@material-ui/core/Typography";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Visibility from "@material-ui/icons/Visibility";
import { AttendanceLocal } from "../../../../../../../@types/attendance-local";
import { useAttendanceLocalExpedientStyles } from "./styles";

type AttendanceLocalExpedientProps = {
  expedient: AttendanceLocal["horario_unidade"];
};

const weekDays: AttendanceLocal["horario_unidade"]["dia_semana"] = [
  "Segunda",
  "Terça",
  "Quarta",
  "Quinta",
  "Sexta",
  "Sábado",
  "Domingo",
];

export default function AttendanceLocalExpedient({
  expedient,
}: AttendanceLocalExpedientProps) {
  const [open, setOpen] = useState(false);
  const { classes } = useAttendanceLocalExpedientStyles();

  return (
    <>
      <Button
        startIcon={<Visibility fontSize="small" />}
        className={classes.button}
        onClick={() => setOpen(true)}
      >
        Visualizar Horários
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: { maxHeight: "90vh", width: "35vw", margin: 0 },
        }}
      >
        <Card>
          <CardHeader
            avatar={<Visibility />}
            title={<Typography variant="h5">Horários</Typography>}
            className={classes.cardHeader}
          />
          <CardContent
            className={classes.cardContent}
            style={{
              padding: 10,
              maxHeight: "60vh",
              overflowY: "auto",
              minWidth: 0,
            }}
          >
            <TableContainer
              className={classes.tableContainer}
              style={{
                maxHeight: "60vh",
                overflowX: "auto",
              }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableTH}>
                      Dia da Semana
                    </TableCell>
                    <TableCell className={classes.tableTH}>
                      Horário de Funcionamento
                    </TableCell>
                    <TableCell className={classes.tableTH}>
                      Horário de Intervalo
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {weekDays.map((weekDay, index) => (
                    <TableRow key={index}>
                      <TableCell>{weekDay}</TableCell>
                      <TableCell>
                        {expedient?.dia_semana.includes(weekDay)
                          ? [
                              expedient?.hora_inicio_manha?.slice(0, 5) || "",
                              expedient?.hora_fim_tarde?.slice(0, 5) || "",
                            ].join(" - ")
                          : "-"}
                      </TableCell>
                      <TableCell>
                        {expedient?.dia_semana.includes(weekDay)
                          ? [
                              expedient?.hora_fim_manha?.slice(0, 5) || "",
                              expedient?.hora_inicio_tarde?.slice(0, 5) || "",
                            ].join(" - ")
                          : "-"}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
          <CardActions className={classes.cardActions}>
            <Button className={classes.button} onClick={() => setOpen(false)}>
              Fechar
            </Button>
          </CardActions>
        </Card>
      </Dialog>
    </>
  );
}
